import React from 'react';

import { useModal } from 'shared/presentation/components/atoms';
import { ICONS } from 'shared/presentation/constants';

import * as S from './styles';

const XIcon = ICONS.X;

interface IModalHeaderProps {
  title: string;
  subtitle?: string;
}

const ModalHeader: React.FC<IModalHeaderProps> = ({ title, subtitle }) => {
  const modal = useModal();

  const hasOnlyOneText = !subtitle;

  return (
    <S.Container data-center={hasOnlyOneText}>
      <div>
        <h2>{title}</h2>

        {!!subtitle && <h4>{subtitle}</h4>}
      </div>

      <button type="button" onClick={modal.close}>
        <XIcon />
      </button>
    </S.Container>
  );
};

export default ModalHeader;
